import React from 'react';
import ButtonCreate from '../../components/actions/ButtonCreate';
import ButtonUser from '../../components/actions/ButtonUser';
import { Home } from '../../components/navigation/Home';
import { Dashboard } from '../../components/navigation/Dashboard';
import { MySurveys } from '../../components/navigation/MySurveys';
import { Pricing } from '../../components/navigation/Pricing';
import { TeamMenu } from '../../components/navigation/TeamMenu';
import { UserMenu } from '../../components/user-menu';
import { InfoMenu } from '../../components/info-menu';
import { Variant } from '../types';

const variant: Variant = {
  brand: 'SurveyMonkey',
  getMenuItems: (experiment): JSX.Element[] => {
    // Global Header experiment
    // https://momentiveai.atlassian.net/browse/HOME-247
    // https://admin.surveymonkey.com/experiments/surveymonkey/2048
    const lihpTreatment = experiment?.lihpHeader?.treatment;

    return [
      ...(lihpTreatment === 'has_lihp'
        ? [<Home key="menu-home" />]
        : [
            /* eslint-disable react/jsx-indent */
            <Dashboard key="menu-dashboard" />,
            <MySurveys key="menu-surveys" />,
            /* eslint-enable */
          ]),
      <TeamMenu key="menu-team" />,
      <Pricing key="menu-pricing" />,
    ];
  },
  actions: [
    <ButtonUser key="action-user" />,
    <ButtonCreate key="action-create" />,
  ],
  info: [<InfoMenu key="menu-info" />],
  user: [<UserMenu key="menu-user" />],
  homePage: '/',
};

export default variant;
